import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ReactModal from 'react-modal';
import _isEqual from 'lodash/isEqual';
import { HookForm } from '../../validation/HForm';
import UnitSelection from './UnitSelection/UnitSelection';
import { authActions } from '../../actions/auth';
import { getAvailableCashboxes, selectionWorkSession } from '../../redux/actions/dashboardAction';
import dashboardSchema from '../../validation/scheme/dashboardSchema';
import { Message } from '../utilites';

import './login.scss';
import '../../assets/styles/components/_forms.scss';

import EyeIcon from '../../assets/icons/eye.svg';
import EyeShowIcon from '../../assets/icons/eye-show.svg';
import {config} from '../../helpers/config'
import LogoDemo from "../utilites/LogoDemo/LogoDemo";

const Login = () => {
  const { cashboxes, commonError, department } = useSelector(({ dashboard }) => dashboard);

  const [state, setState] = useState({
    login: '',
    password: '',
    passwordHidden: true,
    showLoginError: false,
    isOpen: false,
    error: '',
  });

  const dispatch = useDispatch();

  const history = useHistory();

  const buildVersion = config().buildVersion ? `ver.${config().buildVersion}` : ''

  useEffect(()=> {
    return () => {
      setState((prev) => ({
        ...prev,
        error: '',
      }));
    }
  }, [] )

  useEffect(() => {
    if (authActions.checkSession() && authActions.checkWorkSession()) {
      history.push('/search-results/clients');
    }
  }, [authActions.checkSession]);

  useEffect(() => {
    if (!_isEqual(department, {})) {
      setState((prev) => ({
        ...prev,
        isOpen: false,
      }));

      history.push('/search-results/clients');
    }
  }, [department, history]);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogin = async () => {
    let response = await authActions.login(state.login, state.password);

    if (response === 'success') {
      setState((prev) => ({
        ...prev,
        isOpen: true,
      }));
      dispatch(getAvailableCashboxes());
    } else {
      setState((prev) => ({
        ...prev,
        showLoginError: true,
        error: response
      }));
    }
  };

  const showPassword = () => {
    setState((prev) => ({
      ...prev,
      passwordHidden: !prev.passwordHidden,
    }));
  };

  const handleSubmit = (data) => dispatch(selectionWorkSession(data.availableDepartments));

  const handleGoBack = () => {
    authActions.logout();
    setState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  return (
    <main>
      <div className="login-container">
        <div className='login-logoConteiner'>
          <LogoDemo />
        </div>
        <div className='form-login'>
          <h1>Авторизация</h1>
          <form>
            {state.showLoginError && (
              <Message
                type={'error'}
                text={state.error}
              />
            )}
            <div className="form-element">
              <label className="form-element-label" htmlFor="login">
                Логин
              </label>
              <div className="form-element-data">
                <input
                  className="input"
                  type="text"
                  name="login"
                  id="login"
                  value={state.login}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="form-element">
              <label className="form-element-label" htmlFor="password">
                Пароль
              </label>
              <div className="form-element-data">
                <input
                  className="input"
                  type={state.passwordHidden ? 'password' : 'text'}
                  name="password"
                  id="password"
                  value={state.password}
                  onChange={handleInputChange}
                />
                <div className="form-element-data-trigger">
                  <button type="button" onClick={showPassword}>
                    <div className={state.passwordHidden ? 'icon' : 'd-none'}>
                      <EyeShowIcon />
                    </div>
                    <div className={state.passwordHidden ? 'd-none' : 'icon'}>
                      <EyeIcon />
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div className="form-actions">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a className="button-large" onClick={handleLogin}>
                Войти в систему
              </a>
            </div>
          </form>
        </div>
        <div className="login-copyright">
          <p>{'© 2021, ONE.app'} {buildVersion}</p>
        </div>
        <div className="login-bg">{/* <LoginBg /> */}</div>
      </div>
      <ReactModal
        isOpen={state.isOpen}
        contentLabel="Modal"
        className="modal-container"
        overlayClassName="modal-overlay">
        <HookForm onSubmit={handleSubmit} validationSchema={dashboardSchema}>
          <div className="modal-header dashboard">
            <h2>Выбор подразделения</h2>
          </div>
          <div className="modal-body">
            <UnitSelection h="true" cashboxes={cashboxes} commonError={commonError} />
          </div>
          <div className="modal-footer">
            <button className="button" type="submit">
              Сохранить
            </button>
            <button className="button-light" type="button" onClick={handleGoBack}>
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
    </main>
  );
};

export default Login;
